import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { SignupSuccessComponent } from './signup-success/signup-success.component';
import { LoginComponent } from './login/login.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';
import { ResetPasswordComponent } from './reset-password/reset-password.component';
import { LogoutComponent } from './logout/logout.component';
import { UserProfileComponent } from './user-profile/user-profile.component';
import { AlwaysAuthGuardService } from './always-auth-guard.service';
import { PropertiesComponent } from './properties/properties.component';
import { HomeComponent } from './home/home.component';
import { ArticleComponent } from './article/article.component';
import { ContactUsComponent } from './contact-us/contact-us.component';

// import { AssessmentComponent } from './assessment/assessment.component';

const routes: Routes = [
    {path: '', redirectTo: '/home', pathMatch: 'full'},
    {path: 'home', component: HomeComponent},
    {path: 'signup', loadChildren: './signup/signup.module#SignupModule'},
    {path: 'signup-success', component: SignupSuccessComponent},
    {path: 'login', component: LoginComponent},
    // { path: 'dashboard', component: DashboardComponent, canActivate: [AlwaysAuthGuardService] },
    {path: 'dashboard', component: DashboardComponent},

    {path: 'forgot-password', component: ForgotPasswordComponent},
    {path: 'reset-password', component: ResetPasswordComponent},
    {path: 'logout', component: LogoutComponent},
    {path: 'user-profile', component: UserProfileComponent, canActivate: [AlwaysAuthGuardService]},
    /* , canActivate: [AlwaysAuthGuardService] */
    {path: 'properties', component: PropertiesComponent, canActivate: [AlwaysAuthGuardService]},
    {path: 'assessment', loadChildren: './assessment/assessment.module#AssessmentModule', canActivate: [AlwaysAuthGuardService]},
    {path: 'article', component: ArticleComponent},
    {path: 'contact-us', component: ContactUsComponent}

];

@NgModule( {
    imports: [RouterModule.forRoot( routes, {useHash: true} )],
    exports: [RouterModule]
} )
export class AppRoutingModule {
}
